//change this file when the roles are changed in the db
const roles = [
  { id: "Administrator", name: "Administrator", backend_id: 1 },
  { id: "Project Manager", name: "Project Manager", backend_id: 3 },
  { id: "Salesperson", name: "Salesperson", backend_id: 2 },
];

export default roles;
